import { render, staticRenderFns } from "./ProjectContent.vue?vue&type=template&id=3e913c48&scoped=true&"
import script from "./ProjectContent.vue?vue&type=script&lang=js&"
export * from "./ProjectContent.vue?vue&type=script&lang=js&"
import style0 from "./ProjectContent.vue?vue&type=style&index=0&id=3e913c48&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e913c48",
  null
  
)

export default component.exports